import {
  Extensions,
  generateHTML,
  generateText,
  JSONContent,
} from '@tiptap/core';

import { hasTextInRichtext } from 'approot/shared/richtext/richtext.utils';

export function isRichtextValueEmpty(richtext?: JSONContent | null) {
  return !richtext || !!(richtext && !hasTextInRichtext(richtext));
}

export function getRichtextValue(
  richtext: JSONContent | null | undefined,
  extensions: Extensions
) {
  if (richtext && !isRichtextValueEmpty(richtext || undefined)) {
    return generateHTML(richtext, extensions);
  }
  return '';
}

export function getRichtextTextValue(
  richtext: JSONContent | null | undefined,
  extensions: Extensions
) {
  if (richtext && !isRichtextValueEmpty(richtext || undefined)) {
    return generateText(richtext, extensions);
  }
  return '';
}
